import { connect } from '@cerebral/react'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import { state } from 'cerebral'
import { DateTime } from 'luxon'
import React, { useCallback, useMemo } from 'react'

const timeFormat = 'h:mma'

const HourMinutesText = connect(
  {
    timezone: state`account.currentUser.timezone`,
  },

  ({ field, form, timezone, label, size, disabled, placeholder }) => {
    const displayValue = field.value || (disabled && placeholder) || null
    const value = useMemo(() => (displayValue ? DateTime.fromFormat(displayValue, timeFormat, { zone: timezone }) : null), [displayValue, timezone])
    const onChange = useCallback(
      (dt) => {
        form.setFieldValue(field.name, dt ? dt.toFormat(timeFormat).toLowerCase() : dt)
      },
      [form, field]
    )

    return (
      <TimePicker
        size={size}
        label={label}
        value={value}
        onChange={onChange}
        disabled={disabled}
        slotProps={{
          actionBar: {
            actions: ['clear', 'accept'],
          },
        }}
      />
    )
  }
)

export default HourMinutesText
